import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 0.61, 0.24, 1];

// Subtle ink-soak reveal: words bleed in from a blur, like ink soaking into paper.
export const InkText = ({
  text,
  as: Tag = "span",
  className = "",
  delay = 0,
  stagger = 0.05,
  amount = 0.35,
  once = true,
  testId,
}) => {
  const words = String(text).split(" ");
  return (
    <Tag className={className} data-testid={testId}>
      {words.map((word, i) => (
        <span key={i} style={{ display: "inline-block", overflow: "visible" }}>
          <motion.span
            style={{ display: "inline-block", willChange: "filter, opacity, transform" }}
            initial={{ opacity: 0, filter: "blur(10px)", y: "0.12em" }}
            whileInView={{ opacity: 1, filter: "blur(0px)", y: 0 }}
            viewport={{ once, amount }}
            transition={{ duration: 0.95, delay: delay + i * stagger, ease: EASE }}
          >
            {word}
          </motion.span>
          {i < words.length - 1 ? "\u00A0" : ""}
        </span>
      ))}
    </Tag>
  );
};

// Masked line reveal (used for the hero signature moment).
export const MaskLine = ({ children, className = "", delay = 0 }) => (
  <span style={{ display: "block", overflow: "hidden", paddingBottom: "0.22em", marginBottom: "-0.22em" }} className={className}>
    <motion.span
      style={{ display: "block", willChange: "transform, filter" }}
      initial={{ y: "110%", filter: "blur(6px)" }}
      animate={{ y: "0%", filter: "blur(0px)" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Fade = ({ children, className = "", delay = 0, y = 16, testId, ...rest }) => (
  <motion.div
    className={className}
    data-testid={testId}
    {...rest}
    initial={{ opacity: 0, y, filter: "blur(6px)" }}
    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    viewport={{ once: true, amount: 0.4 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);
